import { useAffiliateRegConfig } from '@/modules/promo';
import { useGetCommonStore } from '@/store';
import { REGISTRATION_CONFIGS } from '../helpers';

export const useRegModalTheme = () => {
  const useCommonStore = useGetCommonStore();
  const { regModalTheme } = useAffiliateRegConfig();

  const registrationTheme =
    regModalTheme || useCommonStore.use.registrationTheme();

  return (
    REGISTRATION_CONFIGS[registrationTheme] || REGISTRATION_CONFIGS.default
  );
};
